import React, { PropsWithChildren } from "react";
//#region types
import { HTMLConstants } from "utils/constants";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { CustomFormValidations, DialogQueue, LoadingWithLogoFixed, SpeedDialContainer } from "components/common";
import { useInitialSetup, Header, LeftNav } from "components/layout";
import { WelcomeGuideIntroductions, useWelcomeGuideHelpers } from "components/welcomeGuide";
import { useSyncSelectedCompanyTodoCard } from "components/allCompanies";
import { ErrorBoundary } from "components/error";
import { WintCardPopup } from "components/receipt";
import { MobileAppPromotionPopup } from "components/mobileAppPromotion";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const Layout: React.FC<PropsWithChildren> = (props) => {
  const { hasCompany } = useInitialSetup();
  const { showWelcomeGuide } = useWelcomeGuideHelpers();
  useSyncSelectedCompanyTodoCard();

  return (
    <>
      <Grid container>
        <Grid container direction="row">
          <Grid item>
            <LeftNav />
          </Grid>
          <Grid item xs className={clsx(cssExports.contentWrapper)}>
            <Header />
            <Grid container className={clsx(cssExports.content, showWelcomeGuide ? cssExports.blur : "")}>
              {hasCompany ? <ErrorBoundary>{props.children}</ErrorBoundary> : <LoadingWithLogoFixed />}
            </Grid>
          </Grid>
        </Grid>
        <DialogQueue />
        {hasCompany && <SpeedDialContainer />}
        <div id={HTMLConstants.LayoutPortalId} className={cssExports.animationOverlay}></div>
        <CustomFormValidations />
      </Grid>
      <WelcomeGuideIntroductions />
      {hasCompany && <WintCardPopup />}
      {hasCompany && <MobileAppPromotionPopup />}
    </>
  );
};

export default Layout;
